import cn from "classnames";
import { NumberStepper } from "@hicya/ui";

import { DayPicker } from "@/components/form/day-picker";

import styles from "./schedule-config.module.scss";

import type { ScheduleType } from "@hicya/habits-shared/db";

interface ScheduleConfigProps {
  scheduleType: ScheduleType;
  onScheduleTypeChange: (type: ScheduleType) => void;
  days: number[];
  onDaysChange: (days: number[]) => void;
  count: number;
  onCountChange: (count: number) => void;
  interval: number;
  onIntervalChange: (interval: number) => void;
}

const SCHEDULE_OPTIONS: Array<{ type: ScheduleType; label: string }> = [
  { type: "daily", label: "Every day" },
  { type: "specific_days", label: "Specific days" },
  { type: "x_per_week", label: "X per week" },
  { type: "x_per_month", label: "X per month" },
  { type: "every_n_days", label: "Every N days" },
];

export function ScheduleConfig({
  scheduleType,
  onScheduleTypeChange,
  days,
  onDaysChange,
  count,
  onCountChange,
  interval,
  onIntervalChange,
}: ScheduleConfigProps) {
  return (
    <div className={styles.container}>
      <div className={styles.options} role="radiogroup" aria-label="Schedule frequency">
        {SCHEDULE_OPTIONS.map((opt) => (
          <button
            key={opt.type}
            type="button"
            className={cn(styles.pill, scheduleType === opt.type && styles.active)}
            onClick={() => onScheduleTypeChange(opt.type)}
            role="radio"
            aria-checked={scheduleType === opt.type}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {scheduleType === "specific_days" && <DayPicker value={days} onChange={onDaysChange} />}

      {scheduleType === "x_per_week" && (
        <NumberStepper
          value={count}
          onChange={onCountChange}
          min={1}
          max={7}
          label="Times per week"
        />
      )}

      {scheduleType === "x_per_month" && (
        <NumberStepper
          value={count}
          onChange={onCountChange}
          min={1}
          max={30}
          label="Times per month"
        />
      )}

      {scheduleType === "every_n_days" && (
        <NumberStepper
          value={interval}
          onChange={onIntervalChange}
          min={2}
          max={365}
          label="Every N days"
        />
      )}
    </div>
  );
}
